var _path, _path2, _path3, _rect, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#dcd5f2",
    stroke: "#8b75a1",
    strokeMiterlimit: 10,
    d: "M9.5,0.5h-3c-0.552,0-1,0.448-1,1v9c0,0.552,0.448,1,1,1h3 c0.552,0,1-0.448,1-1v-9C10.5,0.948,10.052,0.5,9.5,0.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b75a1",
    d: "M2,6h12v1H2V6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b75a1",
    d: "M2,5h1v3H2V5z M13,5h1v3h-1V5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5.7,
    height: 1,
    x: 5.1,
    y: 6,
    fill: "#8b75a1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b75a1",
    d: "M12,6.5v4c0,1.4-1.1,2.5-2.5,2.5H9H8.5h-1H7H6.5C5.1,13,4,11.9,4,10.5v-4H3v4C3,12.4,4.6,14,6.5,14 H7v1H5v1h2h2h2v-1H9v-1h0.5c1.9,0,3.5-1.6,3.5-3.5v-4H12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.51aeba0a43d5dd70f6d9babe37926214.svg";
export { ForwardRef as ReactComponent };